/* @flow */

export const invitationsTab = 'invitations';
export const confirmedBraindatesTab = 'braindates';

export const participantsListModalId = 'participants-list-modal-id';
